<template>
  <div class="preview-section-hover-button">
    <div class="sectionHover">
      <!-- Color：背景色を変更 -->
      <div class="button" @click="backgroundColorButton">
        <div class="content">
          <div class="icon"
            :style="buttonColor"
            :class="{transparent:isTransparent}"/>
        </div>
        <span class="name">Color</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['section'],
  data () {
    return {
      color: this.section.styles.background, // セクションの背景色
    }
  },
  computed: {
    isTransparent () {
      return this.sectionBackgroundColor === 'transparent'
    },
    // 表示しているカラーピッカー
    currentColorPicker () {
      return this.$store.getters.getStatusColorPicker
    },
    // 背景色変更ボタンに表示する四角の色
    buttonColor () {
      let backgroundColor = this.sectionBackgroundColor
      let borderColor = backgroundColor

      // 背景色：セクションの背景色が透明の場合、スウォッチの背景色は未設定にする（CSSで設定するため）
      if (backgroundColor === 'transparent') backgroundColor = ''

      // 枠線：背景色が白または透明の場合、薄い灰色にする
      if (backgroundColor === '#FFFFFF' || !backgroundColor) borderColor = '#CCCCCC'

      // styleをまとめて設定するため、オブジェクトで返す
      const buttonColor = {
        background: backgroundColor,
        border: '1px solid' + borderColor
      }
      return buttonColor
    },
    sectionBackgroundColor () {
      return this.$store.getters.findSectionStyle(this.section.name, 'background')
    },
  },
  methods: {
    backgroundColorButton () {
      // セクションID：すでに同じセクションでカラーピッカーを表示している場合、空にする
      const sectionId = this.currentColorPicker.sectionId === this.section.id ? null : this.section.id
      this.$store.commit('updateStatusColorPicker', { prop: 'sectionId', value: sectionId })

      // セレクタとプロパティ：何らかのセクションでカラーピッカーを表示している場合、空にする
      if (sectionId) {
        this.$store.commit('updateStatusColorPicker', { prop: 'selector', value: null })
        this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: null })
      }
    },
  },
  watch: {
    'currentColorPicker.sectionId' (value) {
      if (value) {
        // カラーピッカーを表示しているセクションIDがある場合、preview側の画面であることを示す
        //  セクション数の分だけ更新が行われてしまうので、同一セクションで一回更新する
        if (value === this.section.id) {
          this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: 'preview' })
        }
      } else {
        // カラーピッカーを表示しているセクションIDがない＆画面がpaletteでない場合、非表示であることを示す
        //  セクション数の分だけ更新が行われてしまうので、一回更新する
        if (this.currentColorPicker.pane && this.currentColorPicker.pane !== 'palette') {
          this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: null })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
// セクションにマウスホバーで表示される枠
.sectionHover {
  background: #fff;
  top: 10px;
  display: flex;
  filter: drop-shadow(5px 5px 5px rgba(0,0,0,0.2));
  font-size: 8px;
  position: absolute;
  // 各種ボタン
  .button {
    cursor: pointer;
    height: 50px;
    padding: 5px;
    text-align: center;
    width: 50px;
    // 以下、設定しないとセクションのスタイル設定が反映されてしまう
    line-height: normal;
    // 各種ボタン：マウスホバー時
    &:hover {
      background: #e6e6e6;
    }
    // 各種ボタン：表示部分
    .content {
      color: #666;
      width: 100%;
      height: 25px;
      padding-top: 4px;
      margin-bottom: 2px;
      // 各種ボタン：アイコン本体
      .icon {
        width: 20px;
        height: 20px;
        margin: 0 auto;
        border-radius: 5px;
      }
    }
  }
  // ボタンのテキスト
  span {
    color: #666;
    font-size: 0.8rem;
    font-family: -apple-system,Segoe UI,Helvetica Neue,Hiragino Kaku Gothic ProN,"メイリオ",meiryo,sans-serif;
  }
}

// 背景色ボタンの四角：透明を選択した場合 ※暫定版：後で市松模様の画像等用意する？
.transparent {
  background: #fff;
  background-image:
    linear-gradient(135deg,#ddd 25%, transparent 25%, transparent 75%, #ddd 75%),
    linear-gradient(135deg,#ddd 25%, transparent 25%, transparent 75%, #ddd 75%);
  background-position: 0 0, 9px 9px;
}
</style>
